export const NAMESPACE = "@greg-brandon/escorting-officer-coordinator";